import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import { TICKET_MESSAGES } from './constants';

interface PurchaserParticipationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onYes: () => void;
  onNo: () => void;
  /** Course / Intuto collection: enroll wording */
  useEnrollmentCopy?: boolean;
}

export const PurchaserParticipationModal: React.FC<PurchaserParticipationModalProps> = ({
  isOpen,
  onClose,
  onYes,
  onNo,
  useEnrollmentCopy,
}) => {
  const participation = useEnrollmentCopy
    ? TICKET_MESSAGES.PURCHASER_PARTICIPATION_ENROLLMENT
    : TICKET_MESSAGES.PURCHASER_PARTICIPATION;

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{participation.TITLE}</ModalHeader>
        <ModalCloseButton />
        
        <ModalBody>
          <VStack align="stretch" spacing={4}>
            <Text>
              {participation.DESCRIPTION}
            </Text>
            <Text textStyle="compact" color="#333333">
              If yes, your name and email will be pre-filled for the first attendee (you can edit it later).
            </Text>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose}>
            {participation.CANCEL}
          </Button>
          <Button variant="outline" mr={3} onClick={onNo}>
            {participation.NO}
          </Button>
          <Button colorScheme="primary" onClick={onYes}>
            {participation.YES}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

